// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__32ALf","title":"AfterBackImages_title__1ViJQ","images":"AfterBackImages_images__2Ns7A"};